<div class="root" skyTranslationGuard="skypro-message-request">
  <div
    class="editor drag-drop-area"
    [class.-fileover]="fileOver"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    @if (showAuthorData) {
      <div class="avatar">
        <vim-core-user-avatar
          [user]="currentUser$ | async"
          [avatarUrl]="currentUserAvatarUrl$ | async"
          [size]="40"
        ></vim-core-user-avatar>
      </div>
    }

    <div class="message" [class.-with-avatar]="showAuthorData">
      @if (showAuthorData) {
        <div class="author-name">
          {{ currentUserName$ | async }}
        </div>
      }

      @if (!isPlainTextMode && !isMessengerMode) {
        <app-text-editor
          class="textarea"
          data-test="сообщение"
          [placeholder]="placeholder"
          [content]="message$ | async"
          [hasAutofocus]="hasAutofocus"
          [disabled]="isTextareaDisabled()"
          [scrollingContainer]="scrollingContainer"
          (contentChange)="onMessageChange($event)"
        ></app-text-editor>
      }

      @if (isPlainTextMode) {
        <textarea
          class="plain-textarea"
          data-test="сообщение"
          [placeholder]="placeholder"
          [value]="message$ | async"
          (input)="onTextareaChange($event)"
        ></textarea>
      }

      @if (isMessengerMode) {
        <div class="messenger-input-group">
          @if (allowAttachments && !isTextareaDisabled()) {
            <div class="messenger-file-upload">
              <ds-button
                class="messenger-upload"
                size="m"
                type="secondary"
                data-test="прикрепить файл"
                [isAloneIcon]="true"
              >
                <ds-icon-attach icon></ds-icon-attach>
              </ds-button>

              <label class="file-upload-label">
                @if (allowedAttachmentTypes) {
                  <input
                    class="file-upload-input"
                    type="file"
                    [accept]="allowedAttachmentTypes.join(', ')"
                    (change)="onSelectFile($event)"
                    multiple
                  />
                } @else {
                  <input
                    class="file-upload-input"
                    type="file"
                    (change)="onSelectFile($event)"
                    multiple
                  />
                }
              </label>
            </div>
          }

          <textarea
            class="messenger-input"
            data-test="сообщение"
            [placeholder]="placeholder"
            [value]="message$ | async"
            (input)="onTextareaChange($event)"
            [autosize]="true"
            [minRows]="1"
            [maxRows]="16"
            autofocus
            enterkeyhint="done"
            [disabled]="isTextareaDisabled()"
            #messengerInput
          ></textarea>

          @if (editMessageContent) {
            <!-- Кнопка "Отменить редактированеи сообение" -->
            <ds-button
              [isAloneIcon]="true"
              class="messenger-submit"
              type="inverted"
              size="m"
              data-test="отменить редактирование сообщения"
              (click)="cancelEditing.emit()"
            >
              <ds-icon-close class="messenger-cancel-icon" icon></ds-icon-close>
            </ds-button>
          }

          <!-- Кнопка "отправить сообщение" -->
          <ds-button
            class="messenger-submit"
            [class.-disabled]="!canSubmit()"
            [disabled]="!canSubmit()"
            [spinner]="isLoading"
            [isAloneIcon]="true"
            (click)="submitMessage()"
            type="primary"
            size="m"
            data-test="отправить"
          >
            <ds-icon-arrow-right class="messenger-submit-icon" icon></ds-icon-arrow-right>
          </ds-button>
        </div>
      }

      @if (attachmentsUpload$ | async; as attachmentsUpload) {
        @if (attachmentsUpload.length) {
          <ul class="attachments-grid">
            @for (
              attachmentUpload of attachmentsUpload;
              track trackByAttachment($index, attachmentUpload)
            ) {
              <li
                class="attachment-item"
                [class.-uploading]="attachmentUpload.status === attachmentStatus.uploading"
                [class.-error]="attachmentUpload.status === attachmentStatus.error"
                [class.-uploaded]="attachmentUpload.status === attachmentStatus.uploaded"
                data-test="прикрепленный файл"
              >
                <skypro-message-uploaded-attachment
                  [attachment]="attachmentUpload"
                  [progress]="progress$ | async"
                  (removeAttachment)="onDeleteAttachment(attachmentUpload.uuid)"
                ></skypro-message-uploaded-attachment>
              </li>
            }
          </ul>
        }
      }

      @if (validationError) {
        <div class="validation-error" [innerHTML]="validationError"></div>
      }

      @if (!isMessengerMode) {
        <div class="buttons">
          @if (allowAttachments) {
            <div class="file-upload button">
              <ds-button
                class="file-upload-button -mobile"
                size="s"
                type="secondary"
                nativeType="button"
                data-test="прикрепить файл"
              >
                <ds-icon-attach class="file-upload-icon -mobile" size="s" iconLeft></ds-icon-attach>
                <span>Прикрепить файл</span>
              </ds-button>

              <ds-button
                class="file-upload-button"
                size="s"
                type="secondary"
                nativeType="button"
                data-test="прикрепить файл"
                [isAloneIcon]="true"
              >
                <ds-icon-attach class="file-upload-icon" size="s" icon></ds-icon-attach>
              </ds-button>

              <label class="file-upload-label">
                @if (allowedAttachmentTypes) {
                  <input
                    class="file-upload-input"
                    type="file"
                    [accept]="allowedAttachmentTypes.join(', ')"
                    (change)="onSelectFile($event)"
                    multiple
                  />
                } @else {
                  <input
                    class="file-upload-input"
                    type="file"
                    (change)="onSelectFile($event)"
                    multiple
                  />
                }
              </label>
            </div>

            <div class="attachment-limits" data-test="ограничения вложений">
              {{ 'skyproLibMessages.attachmentLimits' | transloco: attachmentLimits }}
            </div>
          }

          @if (showSubmitButton) {
            <div class="custom-actions-slot">
              <ng-content select="[customActions]"></ng-content>
            </div>
            <div class="main-action-slot">
              @if (!editMessageContent) {
                <ds-button
                  [disabled]="
                    isLoading ||
                    submitButtonDisabled ||
                    ((message$ | async)?.length === 0 && (attachmentsUpload$ | async)?.length === 0)
                  "
                  [spinner]="isLoading"
                  (click)="submitMessage()"
                  class="button-send"
                  type="primary"
                  size="s"
                  data-test="отправить"
                >
                  {{ submitButtonCaption ? submitButtonCaption : 'Отправить' }}
                </ds-button>
              }

              @if (editMessageContent) {
                <ds-button
                  type="secondary"
                  size="s"
                  data-test="отменить редактирование сообщения"
                  (click)="cancelEditing.emit()"
                >
                  {{ 'skyproLibMessages.cancel' | transloco }}
                </ds-button>
                <ds-button
                  [disabled]="
                    isLoading ||
                    ((message$ | async)?.length === 0 && (attachmentsUpload$ | async)?.length === 0)
                  "
                  [spinner]="isLoading"
                  (click)="submitMessage()"
                  class="button-send"
                  type="primary"
                  size="s"
                  data-test="сохранить отредактированное сообщение"
                >
                  {{ 'skyproLibMessages.save' | transloco }}
                </ds-button>
              }
            </div>
          }
        </div>
      }
    </div>

    @if (fileOver) {
      <div class="drop-here" (dragleave)="onDragLeave($event)">
        <div class="drop-icon"></div>
        <div class="drop-text">
          {{ 'skyproLibMessages.dragFilesHere' | transloco }}
        </div>
      </div>
    }
  </div>
</div>
